import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function SiteShell({ children }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // On route change scroll to top (or hash target)
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return (
    <div className="bg-[var(--vw-paper)]">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
